import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackTranscriptionCancelEdit.meta';

export const useTrackTranscriptionCancelEdit = () => {
  const { track } = useAnalyticsUtilities();

  const trackTranscriptionCancelEdit = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackTranscriptionCancelEdit };
};
